module.exports = {
    node_env: 'development',
    // node_env: 'test',
    // node_env: 'production',
}

